import { DocumentStatus } from '../models';

export const getStatusRequestSuffix = (status: DocumentStatus) => {
  switch (status) {
    case 'PUBLISHED':
      return 'approve';
    case 'REJECTED':
      return 'reject';
    case 'PENDING':
      return 'pending';
  }
};
